import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'text-action',
    templateUrl:'textAction.html'
})
export class TextActionComponent extends BaseActionComponent{

  public linkForm: FormGroup;
  public level=1;
  public kind='text';
  //limites
  public readonly OPACITY_MIN=0;
  public readonly OPACITY_MAX=1;
  public readonly PADDING_MIN=0;
  public readonly PADDING_MAX=1;
  public readonly FONT_SIZE_MIN=0;
  public readonly FONT_SIZE_MAX=100;
  public readonly WIDTH_MIN=0;
  public readonly WIDTH_MAX=1000;
  public readonly HEIGHT_MIN=0;
  public readonly HEIGHT_MAX=1000;
  public readonly OFFSET_MIN=-1000;
  public readonly OFFSET_MAX=1000;
  public textAligns=[
    {name:'center',kind:'center'},
    {name:'left',kind:'left'},
    {name:'right',kind:'right'}
  ];
  public justifyContents=[
    {name:'center',kind:'center'},
    {name:'flex-start',kind:'flex-start'},
    {name:'flex-end',kind:'flex-end'},
    {name:'space-between',kind:'space-between'}
  ];
  public alignItems=[
    {name:'center',kind:'center'},
    {name:'flex-start',kind:'flex-start'},
    {name:'flex-end',kind:'flex-end'}
  ];

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
    this.linkForm = this.buildForm(null);
  }

  /////////////////////////////////////////////////////////////////////
  // HELPERS
  /////////////////////////////////////////////////////////////////////
  public clamp(value,min,max,fallback){
    if (value==null || value==='' || isNaN(Number(value))){
      return fallback;
    }
    let n=Number(value);
    if (n<min){return min}
    if (n>max){return max}
    return n;
  }
  //deixa vazio continuar vazio (o motor aplica o default nesses tres)
  public clampOrNull(value,min,max){
    if (value==null || value==='' || isNaN(Number(value))){
      return null;
    }
    return this.clamp(value,min,max,null);
  }
  public isHex(value){
    if (!value){
      return false;
    }
    let v=String(value).trim();
    return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v);
  }
  public safeColor(value,fallback){
    return this.isHex(value) ? value : fallback;
  }
  public hasOffset(o){
    if (!o){
      return false;
    }
    return (Number(o.x)||0)!=0 || (Number(o.y)||0)!=0 || (Number(o.z)||0)!=0;
  }

  /////////////////////////////////////////////////////////////////////
  // FORM
  /////////////////////////////////////////////////////////////////////
  public buildForm(param){
    let p=param ? param : {};
    let offset=p.offset ? p.offset : {};
    return this.fb.group({
      text: p.text!=null ? p.text : '',
      //vazio = o motor usa dimension.x do item (width) ou 0 (height)
      width: p.width!=null ? p.width : '',
      height: p.height!=null ? p.height : 0,
      //vazio = o motor calcula width * 0.045
      fontSize: p.fontSize!=null ? p.fontSize : '',
      color: this.safeColor(p.color,'#ffffff'),
      backgroundColor: this.safeColor(p.backgroundColor,'#222222'),
      backgroundOpacity: p.backgroundOpacity!=null ? p.backgroundOpacity : 1,
      padding: p.padding!=null ? p.padding : 0.04,
      textAlign: p.textAlign ? p.textAlign : 'center',
      justifyContent: p.justifyContent ? p.justifyContent : 'center',
      alignItems: p.alignItems ? p.alignItems : 'center',
      billboard: p.billboard!=null ? p.billboard : true,
      offset: this.fb.group({
        x: offset.x!=null ? offset.x : 0,
        y: offset.y!=null ? offset.y : 0,
        z: offset.z!=null ? offset.z : 0
      }),
      fontPath: p.fontPath!=null ? p.fontPath : 'assets/fonts/'
    })
  }

  /////////////////////////////////////////////////////////////////////
  // PERSISTENCIA: monta action.param
  /////////////////////////////////////////////////////////////////////
  public buildParam(){
    let v=this.linkForm['_value'];
    let param:any={
      text: v.text!=null ? v.text : '',
      color: this.safeColor(v.color,'#ffffff'),
      backgroundColor: this.safeColor(v.backgroundColor,'#222222'),
      backgroundOpacity: this.clamp(v.backgroundOpacity,this.OPACITY_MIN,this.OPACITY_MAX,1),
      padding: this.clamp(v.padding,this.PADDING_MIN,this.PADDING_MAX,0.04),
      textAlign: v.textAlign ? v.textAlign : 'center',
      justifyContent: v.justifyContent ? v.justifyContent : 'center',
      alignItems: v.alignItems ? v.alignItems : 'center',
      billboard: v.billboard ? true : false,
      fontPath: v.fontPath!=null ? v.fontPath : 'assets/fonts/'
    };
    //width/height/fontSize so vao quando o usuario define
    //(deixando o motor aplicar dimension.x / 0 / width*0.045)
    let width=this.clampOrNull(v.width,this.WIDTH_MIN,this.WIDTH_MAX);
    if (width!=null){
      param.width=width;
    }
    let height=this.clampOrNull(v.height,this.HEIGHT_MIN,this.HEIGHT_MAX);
    if (height!=null && Number(height)>0){
      param.height=height;
    }
    let fontSize=this.clampOrNull(v.fontSize,this.FONT_SIZE_MIN,this.FONT_SIZE_MAX);
    if (fontSize!=null){
      param.fontSize=fontSize;
    }
    if (this.hasOffset(v.offset)){
      param.offset={
        x: this.clamp(v.offset.x,this.OFFSET_MIN,this.OFFSET_MAX,0),
        y: this.clamp(v.offset.y,this.OFFSET_MIN,this.OFFSET_MAX,0),
        z: this.clamp(v.offset.z,this.OFFSET_MIN,this.OFFSET_MAX,0)
      };
    }
    return param;
  }
  public processData(action){
    if (!action){
      action={kind:'text',param:{}}
    }
    let dx=action.param.dx
    let dy=action.param.dy
    action.param=this.buildParam();
    action.param.dx=dx;
    action.param.dy=dy;


  }
  public childrenReloadData(){
    let param=this.action && this.action.param ? this.action.param : {};
    this.linkForm=this.buildForm(param);
  }

    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/textAction.ts